<div style="padding: 150px 0 0 0; margin: auto; text-align: center; visibility: hidden; background-color: #fff" >

</div>

<div *ngFor="let m of policies">
    <ng-container>
    <mat-nav-list class="single-menu active" [ngClass]="urlActive == m.url ? 'active-menu' : ''" *ngIf="!m.hasChildMenu">
        <mat-list-item class="mat-list-item ">
            <p (click)="clickMenu(m.url)" *ngIf="!m.externalURL" matLine style="margin: auto" >
                <mat-icon style="font-size: 19px; color: #979797; margin-bottom: -9px;">{{m.icon}}</mat-icon>
                <span style="margin-left: 15px; font-size: 16px; color: #979797">{{ m.label}}</span>
            </p>
            <p *ngIf="m.externalURL" matLine (click)="externalLoad(m.url)">{{ m.label}}</p>
        </mat-list-item>
    </mat-nav-list>
    </ng-container>
</div>
<mat-nav-list class="single-menu" >
    <mat-list-item class="mat-list-item" (click)="logout()">
        <p  matLine style="margin: auto">
            <mat-icon style="font-size: 19px; color: #979797; margin-bottom: -9px;">reply</mat-icon>
            <span style="margin-left: 15px; font-size: 16px; color: #979797">Close Wallet</span>
        </p>
    </mat-list-item>
</mat-nav-list>

